export const products = [
  {
    id: 1,
    title: 'Metal CamLocks for PUF/Sandwich Panels',
    category: 'COLD ROOM SOLUTIONS',
    description:
      "Microtech's Camlock ensures airtight panel locking to prevent thermal leakage, maintaining uniform temperature inside cold rooms and reducing cooling costs.",
    image: '/assets/camlock.jpeg',
    stampingTypes: [
      'Strong metal construction for durability',
      'Firm interlocking for gap-free joints',
      'High Mechanical Strength for Repeated Use',
      'Corrosion-Resistant,ideal for cold rooms',
      'Easy and quick installation with standard tools'
    ],
  },
  {
    id: 2,
    title: 'Sheet Metal Components',
    category: 'STAMPING SOLUTIONS',
    description: 'Engineered with precision for consistent performance across diverse industrial applications.',
    image: 'https://microtechstampings.lovable.app/assets/product-sheetmetal-80owJ07a.jpg',
    stampingTypes: [
      'High Dimensional Accuracy',
      'Superior Material Strength',
      'Consistent Quality',
      'Custom Fabrication',
      'Cost-Effective Manufacturing',
    ],
    materials: ['Galvanized(GI)',
      'Mild Steel',
      'Stainless Steel',
      'Aluminium',
      'Copper',
      'Brass'],
    
    
  }
];
